module.exports = __webpack_public_path__ + "static/img/icon_cards@2x.8292174b.png";